import { CropFree, ZoomInMap } from "@mui/icons-material";
import { Avatar, Grid, IconButton, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useStyle } from "../style";
import BillingTable from "./billingTable";
import CustomerInfo from "./customerInfo";
import PurchaseInfo from "./purchaseInfo";
import moment from "moment";
import Logo from "../../../../../assets/images/Girlush Logo.png"
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
const StockVerify = () => {
  const classes = useStyle();
  const fullscreenRef = useRef(null);
  const codeRef = useRef(null)
  const [isFull, setIsFull] = useState(false);
  const [data, setData] = useState([])
  const[verifyEnable , setVerifyEnable] = useState('')
  const navigate = useNavigate()
  const [postData, setPostData] = useState({
    docdate: moment().format('YYYY/MM/DD'), 
    partycode: 0,
    amount: 0,
    subtotal_amount: "",
    gst_per: 0,
    gst_amt: 0,
    cess_per: 0,
    cess_amt: 0,
    roff:"",
    company_id: 0,
    mode:"",
    sales_doc_no:"",
    is_individual: 1,
    verifiedCode:[],
    stock_missing_details:[]
  })

  const toggleFullscreen = () => {
    const isFullScreen = document.fullscreenElement
    if(isFullScreen){
      document.exitFullscreen()
      setIsFull(!isFull)
    }
    else{
      fullscreenRef.current.requestFullscreen();
      setIsFull(!isFull)
    }
  };
  
  useEffect(() => {
    const checkFullscreen = () => {
      const isFullScreen = document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement || document.msFullscreenElement;
      setIsFull(!!isFullScreen);
    };
  
    const handleEscapeKey = (event) => {
      if (event.key === 'Escape') {
        checkFullscreen();
      }
    };
  
    document.addEventListener('fullscreenchange', checkFullscreen);
    document.addEventListener('mozfullscreenchange', checkFullscreen);
    document.addEventListener('webkitfullscreenchange', checkFullscreen);
    document.addEventListener('msfullscreenchange', checkFullscreen);
    document.addEventListener('keydown', handleEscapeKey);
  
    return () => {
      document.removeEventListener('fullscreenchange', checkFullscreen);
      document.removeEventListener('mozfullscreenchange', checkFullscreen);
      document.removeEventListener('webkitfullscreenchange', checkFullscreen);
      document.removeEventListener('msfullscreenchange', checkFullscreen);
      document.removeEventListener('keydown', handleEscapeKey);
    };
  }, [setIsFull]);
console.log(verifyEnable)
  return (
    <Grid ref={fullscreenRef} className={classes.root}>
      <Helmet>
        <title>Stock Verification</title>
      </Helmet>
      <Grid className={classes.titleInfo} sx={{paddingBlock:"25px"}}>
        {/* {isFull ? <IconButton onClick={toggleFullscreen}><ZoomInMap /></IconButton>
         : <IconButton onClick={toggleFullscreen}><CropFree /></IconButton>} */}
        <Grid className="flex justify-between items-center">
          <Avatar variant="square" src={Logo} onClick={() => navigate('/dashboard')} sx={{cursor:"pointer",}}/>
          <Typography  fontWeight={600} ml={1} onClick={() => navigate('/dashboard')} sx={{cursor:"pointer",fontSize:20}}>GIRLUSH</Typography>
        </Grid>
        <Typography variant="h5" fontWeight={600}>Stock Verification</Typography>
        <Typography>Press F11 to Full Screen </Typography>
      </Grid>
      <Grid className={classes.contentGrid}>
        <Grid className="w-5/6" sx={{display: 'flex', flexDirection:'column',  flex: 1,height: "calc(100% - 40px)",}}>
          <Grid className="border-b" sx={{height:'fit-content'}}><PurchaseInfo setData={setData} setPostData={setPostData} postData={postData} forwardRef={codeRef} /></Grid>
          <Grid className="p-2 " sx={{flex:1,}}><BillingTable data={data} setData={setData} setPostData={setPostData} forwardRef={codeRef} setVerifyEnable={setVerifyEnable} verifyEnable={verifyEnable}/></Grid>
        </Grid>
        <Grid className="w-1/6 h-full border-l py-2">
          <Grid className="border-b px-3">
            <CustomerInfo setData={setData} data={data} postData={postData} setPostData={setPostData} verifyEnable={verifyEnable} />
          </Grid>
         
        </Grid>
      </Grid>
    </Grid>
  );
};

export default StockVerify;
